import { DefaultApiHead } from '../fetchEnv';

export default {
  downloadQuery: {
    url: '/website/download/query',
  },
  downloadToken: {
    url: '/website/download/token',
  },
  downloadDelele: {
    url: '/website/download/delete',
  },
  downloadSingleUrl: {
    url: '/website/download/download',
    isUrl: true,
  },
  downloadCreate: {
    url: null,
    getUrl: (params) => {
      const type = params ? params.businessType : null;
      let url = '/website/download/createtrade';

      if (type === '1') {
        url = '/website/download/createtrade';
      } else if (type === '2') {
        url = '/website/download/createmerchantstl';
      } else if (type === '3') {
        url = '/website/download/createmerchantstldetail';
      }

      return url;
    },
  },
};



// WEBPACK FOOTER //
// ./src/service/apiConfig/apiDownload.js